import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogHeader,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { LoaderCircle } from 'lucide-react';

interface DeleteCourtConfirmModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleteCourt: () => void;
}

export const DeleteCourtConfirmModal = ({
  isOpen,
  isLoading,
  onOpenChange,
  onDeleteCourt,
}: DeleteCourtConfirmModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader className="space-y-3">
          <DialogTitle className="text-xl">
            ¿Estás seguro de eliminar esta cancha?
          </DialogTitle>
          <DialogDescription className="text-base leading-6">
            Esta acción es permanente y no se podrá deshacer. ¿Querés continuar
            con la eliminación?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Button
            onClick={() => onOpenChange(true)}
            variant="outline"
            className="w-full sm:w-auto"
          >
            Cancelar
          </Button>
          <Button
            onClick={onDeleteCourt}
            variant="destructive"
            className="flex h-10 w-full min-w-full items-center justify-center sm:w-56 sm:min-w-56"
            disabled={isLoading}
          >
            {isLoading ? (
              <LoaderCircle
                className="animate-spin"
                size={'16px'}
              ></LoaderCircle>
            ) : (
              'Proceder con la eliminación'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
